import { AfterViewInit, Component, ElementRef, Inject, ViewChild } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'

@Component({
  selector: 'app-inform-dialog',
  templateUrl: './inform-dialog.component.html',
  styleUrls: ['./inform-dialog.component.scss']
})
export class InformDialogComponent implements AfterViewInit {
  @ViewChild('closeButton', { read: ElementRef }) closeButton: ElementRef<HTMLButtonElement>

  title: string
  message: string
  acceptText: string
  cancelText: string
  toastMessage: string

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    public dialogRef: MatDialogRef<InformDialogComponent>) {
    if (data) {
      this.acceptText = data.acceptText
      this.cancelText = data.cancelText
      this.toastMessage = data.toastMessage
      this.title = data.title
      this.message = data.message
    }

  }

  ngAfterViewInit(): void {
    // MatDialog autoFocus can be overridden by other elements/directives.
    // Force focus to the close button after the dialog is fully rendered.
    const opened$ = (this.dialogRef as any)?.afterOpened?.()
    if (!opened$) {
      return
    }

    opened$.subscribe(() => {
      setTimeout(() => {
        this.closeButton?.nativeElement?.focus()
      }, 0)
    })
  }

  handleCancel() {
    this.dialogRef.close()
  }
}
